import React from 'react';
import s2 from '../imgs/s2.png'

const TourCard = () => {
    return (
        <section className='section-tours' id='section-tours'>
            <div className='u-center-text '>
            <h2 className='heading-secondary secondary-card'>
                Most popular tours
            </h2>
           
            
</div>
<img src={s2} className='s2'/>



<div className='row row-card'>
<div className='col-1-of-3'> 

<div className='card'>

    <div className='card__side card__side--front'>
      <div className='card__picture card__picture--1'>
          &nbsp;
      </div>
      <h4 className='card__heading'>
          <span className='card__heading-span card__heading-span--1'>THE sea explorer</span></h4>
      <div className='card__details'>
          <ul>
                        <li>3 day tours</li>
          <li>Upto 30 people</li>
          <li>2 tour guides</li>
          <li>Sleeping cozy hotels</li>
          <li>Difficulty:easy</li>
          </ul>
      
      </div>
    </div>

    <div className='card__side card__side--back card__side--back-1'>
        <div className='card__cta'>
            <div className='card__price-box'>
            <p className='card__price-only'>Only </p>
            <p className='card__price-value'>$298</p>
            </div>
            <a href='#modal' className='btn btn--white'>Book now! </a>
        </div>
    </div>
 
</div>
</div>
<div className='col-1-of-3'>    
<div className='card'>

    <div className='card__side card__side--front'>
      <div className='card__picture card__picture--2'>
          &nbsp;
      </div>
      <h4 className='card__heading'>
          <span className='card__heading-span card__heading-span--2'>THE Forest explorer</span></h4>
      <div className='card__details'>
          <ul>
                        <li>7 day tours</li>
          <li>Upto 40 people</li>
          <li>6 tour guides</li>
          <li>Sleeping in provided tents</li>
          <li>Difficulty:medium</li>
          </ul>
      
      </div>
    </div>

    <div className='card__side card__side--back card__side--back-2'>
        <div className='card__cta'>
            <div className='card__price-box'>
            <p className='card__price-only'>Only </p>
            <p className='card__price-value'>$498</p>
            </div>
            <a href='#modal' className='btn btn--white'>Book now! </a>
        </div>
    </div>
 
</div>
</div>
<div className='col-1-of-3'>    
<div className='card'>

    <div className='card__side card__side--front'>
      <div className='card__picture card__picture--3'>
          &nbsp;
      </div>
      <h4 className='card__heading'>
          <span className='card__heading-span card__heading-span--3'>THE Snow Adventurer</span></h4>
      <div className='card__details'>
          <ul>
                        <li>5 day tours</li>
          <li>Upto 15 people</li>
          <li>3 tour guides</li>
          <li>Sleeping in luxoriuos hotels</li>
          <li>Difficulty:hard</li>
          </ul>
      
      </div>
    </div>

    <div className='card__side card__side--back card__side--back-3'>
        <div className='card__cta'>
            <div className='card__price-box'>
            <p className='card__price-only'>Only </p>
            <p className='card__price-value'>$898</p>
            </div>
            <a href='#modal' className='btn btn--white'>Book now! </a>
        </div>
    </div>
 
 
</div>
</div>

</div>


<div className='u-center-text u-margin-top-huge'>


<a href='#Discover' className='btn btn--green'>Discover all tours</a>

</div>

        </section>
    )
}

export default TourCard
